import { FC, MouseEvent } from 'react';
import { Button, Tooltip } from '@ibsys/kit';
import { CopyIcon } from 'lucide-react';

type Props = {
  /** Текст, который уходит в буфер обмена */
  text: string;
  /** Подсказка и aria-label кнопки */
  tooltip: string;
  className?: string;
};

/**
 * Кнопка копирования текста в буфер обмена.
 *
 * Клик не всплывает: кнопка живёт внутри строк и карточек со своим переходом, и копирование
 * не должно попутно уводить пользователя со страницы.
 */
export const CopyButton: FC<Props> = ({ text, tooltip, className }) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    navigator.clipboard.writeText(text);
  };

  return (
    <Tooltip tooltip={tooltip}>
      <Button variant="ghost" size="icon" className={className ?? 'size-6'} aria-label={tooltip} onClick={handleClick}>
        <CopyIcon className="size-3.5" />
      </Button>
    </Tooltip>
  );
};
